import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export const FAQItem = ({
  question,
  answer
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#6805DA]/20 last:border-b-0" data-id="element-350" data-mp="a5dl9t4sr9ag">
      <button className="flex justify-between items-center w-full py-5 text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-351" data-mp="e89x90zu075f">
        <h3 className="text-xl font-outfit font-semibold text-white" data-id="element-352" data-mp="3in1cyuklkyie">
          {question}
        </h3>
        <div className="text-[#FFC501]" data-id="element-353" data-mp="3momu4s45zyye">
          {isOpen ? <ChevronUpIcon size={20} data-id="element-354" data-mp="3mn22pbd5cw4r" /> : <ChevronDownIcon size={20} data-id="element-355" data-mp="3mmsadh4mqcvw" />}
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-5' : 'max-h-0'}`} data-id="element-356" data-mp="3rg4vvie0i3kf">
        <p className="text-gray-300 font-manrope pr-8" data-id="element-357" data-mp="2uvcq3tqjp28u">{answer}</p>
      </div>
    </div>;
};